export const scrollToElement = (selector) => {
	const targetEl = document.querySelector(selector);
	if (!targetEl) {
		return;
	}

	window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top);
};
